import styled, { css } from "styled-components";

import { theme } from "../../style";

// full width
export const sectionMixin = css`
  ${({ type }) => (type === "container" ? "padding:0 135px;" : "")}
  ${({ width }) => width && `width: ${width}`}};}
  ${({ height }) => height && `height: ${height}`}};}
  
  margin: ${({ margin }) => (margin ? margin : "0 auto")};
  ${(props) =>
    props.background &&
    `
    background: url(${props.background});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    `}
    ${(props) => props.isSection && `margin: 195px 0;`}
`;

export const Wrapper = styled.div`
  ${sectionMixin};
  ${(props) => (props.isCenter ? "text-align: center;" : "")}
  @media only screen and (min-width: ${theme.breakpoint.tablet}) {
    ${(props) => (props.hasColumns ? "display: flex;" : "")}
  }
  @media only screen and (max-width: ${theme.breakpoint.tablet}) {
    width: 95%;
    ${({ type }) => (type === "container" ? "padding:0 16px;" : "")}
    ${(props) => props.isSection && `margin: 2rem auto;`}
  }
  ${(props) => (props.display ? `display: ${props.display};` : "")}
  ${(props) => (props.direction ? `flex-direction: ${props.direction};` : "")}
  ${(props) =>
    props.spaceStyle ? `justify-content: ${props.spaceStyle};` : ""}
  ${(props) => (props.align ? `align-items: ${props.align};` : "")}
`;
